import { Stack } from '@/components/layout';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { useStyles } from '@/features/player/components/player-profile/player-equipment/styles';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Activity } from 'react';

export function ClubsInfo({
  clubsneeded,
  dominantHand,
  height: heightString,
}: {
  clubsneeded: boolean;
  dominantHand: string;
  height: string;
}) {
  const styles = useStyles();
  const { scale, isTablet } = useScaling();
  const height = heightString ? `${heightString?.replace?.('"', '')}"` : '-';

  return (
    <Stack>
      <Stack direction="row" justify="space-between" align="center" flex={1}>
        <Text
          variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
          transform="uppercase"
          fontWeight={'800'}
          style={styles.title}>
          {STRINGS.player.profile.equipment.golfClubInfoTitle}
        </Text>
      </Stack>
      <Stack
        gap={scale(12)}
        marginTop={scale(12)}
        backgroundColor={isTablet ? undefined : colors['2']}
        paddingBottom={scale(32)}>
        <Stack direction="row" gap={scale(16)}>
          <Stack
            flex={1}
            backgroundColor="white"
            borderRadius={scale(8)}
            paddingX={scale(4)}
            height={scale(60)}
            justify="center"
            align="center"
            gap={scale(12)}
            style={styles.infoCard}>
            <Text variant="Font Inter/Subtitle/Regular" style={styles.infoLabel}>
              {STRINGS.player.mutatePlayer.club.needClub}
            </Text>
            <Text variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px" style={styles.infoValue}>
              {clubsneeded
                ? STRINGS.player.mutatePlayer.club.yes
                : STRINGS.player.mutatePlayer.club.no}
            </Text>
          </Stack>
          <Stack
            flex={1}
            backgroundColor="white"
            borderRadius={scale(8)}
            paddingX={scale(4)}
            height={scale(60)}
            justify="center"
            align="center"
            gap={scale(12)}
            style={styles.infoCard}>
            <Text variant="Font Inter/Subtitle/Regular" style={styles.infoLabel}>
              {STRINGS.player.mutatePlayer.club.dominantHand}
            </Text>
            <Text variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px" style={styles.infoValue}>
              {dominantHand === 'left'
                ? STRINGS.player.mutatePlayer.club.left
                : STRINGS.player.mutatePlayer.club.right}
            </Text>
          </Stack>
          <Activity mode={isTablet ? 'visible' : 'hidden'}>
            <Stack
              flex={1}
              backgroundColor="white"
              borderRadius={scale(8)}
              paddingX={scale(4)}
              height={scale(60)}
              justify="center"
              align="center"
              gap={scale(12)}
              style={styles.infoCard}>
              <Text
                variant="Font Inter/Subtitle/Regular"
                style={styles.infoLabel}
                transform="uppercase">
                {STRINGS.player.mutatePlayer.profile.playerHeight}
              </Text>
              <Text
                variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
                style={styles.infoValue}>
                {height}
              </Text>
            </Stack>
          </Activity>
        </Stack>
        <Activity mode={!isTablet ? 'visible' : 'hidden'}>
          <Stack
            flex={0}
            alignSelf="flex-start"
            width="48%"
            backgroundColor="white"
            borderRadius={scale(8)}
            paddingX={scale(4)}
            height={scale(60)}
            justify="center"
            align="center"
            gap={scale(12)}
            style={styles.infoCard}>
            <Text
              variant="Font Inter/Subtitle/Regular"
              style={styles.infoLabel}
              transform="uppercase">
              {STRINGS.player.mutatePlayer.profile.playerHeight}
            </Text>
            <Text variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px" style={styles.infoValue}>
              {height}
            </Text>
          </Stack>
        </Activity>
      </Stack>
    </Stack>
  );
}
